// extracted by mini-css-extract-plugin
export default {"wrapper":"DT-z","ratingContainer":"ET-z","ratingValue":"FT-z","starSprite":"GT-z","ratingLabel":"HT-z","error":"IT-z","errorBox":"JT-z"};